import React from "react";

import PanelContent from "Components/Panels/PanelContent";

export function RapidTestsSection() {
  const items = [];

  return (
    <PanelContent title="Testes rápidos">
      {!items.length ? (
        <p className="text-gray">
          Nenhum teste rápido vinculado a esta unidade.
        </p>
      ) : (
        <div className="row">
          <div className="sm-12">
            <ul
              className="list-unstyled"
              style={{ margin: 0, padding: 0, listStyle: "none" }}
            >
              {items.map((item) => (
                <li
                  key={item.id}
                  style={{
                    padding: "0.75rem 0",
                    borderBottom: "1px solid var(--color-border, #e5e5e5)",
                  }}
                >
                  <strong className="text-gray">{item.product}</strong>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </PanelContent>
  );
}
